import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate, useParams } from "react-router";
import {
  fetchChatUsers,
  fetchMyChats,
  fetchChatHistory,
} from "../features/chats/chatThunks.js";
import ChatSidebar from "../components/ChatSidebar.jsx";
import "../styles/chats/chatslayout.css";

const ChatLayout = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { chatId } = useParams();

  const currentUser = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);
  const myChats = useSelector((state) => state.chat.myChats) || [];
  const loading = useSelector((state) => state.chat.loading);

  const userRole = (currentUser?.role || "").toLowerCase();
  const isPatient = userRole === "patient";

  // Si es paciente, no cargamos nada de chats y lo mandamos fuera
  useEffect(() => {
    if (!token || !currentUser) return;

    if (isPatient) {
      navigate("/appointments", { replace: true });
      return;
    }

    dispatch(fetchChatUsers());
    dispatch(fetchMyChats());
  }, [dispatch, token, currentUser, isPatient, navigate]);

  const sortedChats = useMemo(() => {
    return [...myChats].sort(
      (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
    );
  }, [myChats]);

  // Redirección al primer chat solo si no es paciente
  useEffect(() => {
    if (isPatient) return;

    const isIndex =
      location.pathname === "/chats" ||
      location.pathname === "/chats/";
    const query = new URLSearchParams(location.search);
    const receiverIdFromQuery = query.get("to");
    const isCompose = Boolean(
      location.state?.receiverId || receiverIdFromQuery
    );

    if (isIndex && !location.state?.receiverId && sortedChats.length > 0) {
      navigate(`/chats/${sortedChats[0].id}`, { replace: true });
    }
  }, [location.pathname, location.state, sortedChats, navigate, isPatient, location.search]);

  const handleSelect = (id) => {
    const chat = sortedChats.find((c) => c.id === id);
    const meId = currentUser?.id;
    const peer =
      (chat?.participants || []).find((p) => p.id !== meId) ||
      chat?.receiver ||
      chat?.sender;
    navigate(`/chats/${id}`, { state: { receiverId: peer?.id } });
  };

  // Si es paciente, no renderizamos nada (ya se redirige en el useEffect)
  if (isPatient) {
    return null;
  }

  return (
    <div className="chat-shell">
      <aside className="chat-panel-left">
        <ChatSidebar
          chats={sortedChats}
          activeId={chatId ? Number(chatId) : null}
          onSelect={handleSelect}
          loading={loading}
        />
      </aside>
      <main className="chat-panel-right">
        <Outlet />
      </main>
    </div>
  );
};

export default ChatLayout;